import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import {
  API_ADMIN_LIO_PREVENCIONISTA,
  API_ADMIN_GERENCIA,
  URL_SUPPORT,
  ROW_COUNT,
  ROW_COUNT_MAX,
  API_ADMIN_CONTRATISTA_SUBCONTRATISTA,
  API_ADMIN_CONTRATISTA_RESPONSABLE,
} from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import ILIOPrevencionista from "../../../entities/ILIOPrevencionista";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import IGerencia from "../../../entities/IGerencia";
import { IEmpresaInspectora } from "../../../entities/IEmpresaInspectora";
import { IINspectorContratista } from "../../../entities/IInspectorContratista";
import { IEmpresaInspeccionada } from "../../../entities/IEmpresaInspeccionada";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
interface ILIOPrevencionistaProps {
  items?: Array<any>;
  cbGerencia?: Array<IGerencia>;
  cbEmpresaInspectora?: Array<IEmpresaInspectora>;
  cbInspectorContratista?: Array<IINspectorContratista>;
  cbEmpresaInspeccionada?: Array<IEmpresaInspeccionada>;
  cbEmpresaInspeccionada2?: Array<IEmpresaInspeccionada>;
  is_test?: boolean;
}
const component = (titulo: string) => {
  return <RenderTitle title={titulo} />;
};

const componentValue = (value: any) => {
  return <RenderValue value={value} />;
};

function linkRender() {
  return (
    <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
      <i className="bi bi-search"></i>
    </a>
  );
}

const LIOPrevencionista = ({
  is_test,
  items,
  cbGerencia,
  cbEmpresaInspectora,
  cbInspectorContratista,
  cbEmpresaInspeccionada,
  cbEmpresaInspeccionada2,
}: ILIOPrevencionistaProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboIC, setComboIC] = useState<Array<IINspectorContratista>>(cbInspectorContratista || []);
  const [comboEI, setComboEI] = useState<Array<IEmpresaInspectora>>(cbEmpresaInspectora || []);
  const [comboEID, setComboEID] = useState<Array<IEmpresaInspeccionada>>(cbEmpresaInspeccionada || []);

  let comboEID2: IEmpresaInspeccionada[] = [];
  const [comboPEI, setComboPEI] = useState<Array<IEmpresaInspeccionada>>(cbEmpresaInspeccionada2 || []);
  const [comboGrc, setComboGrc] = useState<Array<IGerencia>>(cbGerencia || []);
  const [txtPrevencionista, setPrevencionista] = useState("");
  const [txtPrevencionistaInspeccionada, setPrevencionistaInspeccionada] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(0);
  const [selectedItem, setSelectedItem] = useState({});
  const columnLIOPrevencionista = createColumnHelper<ILIOPrevencionista>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [loaded, setLoaded] = useState(false);

  let columnsDef = [
    columnLIOPrevencionista.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<ILIOPrevencionista, number>) => componentValue(info.getValue()),
      header: () => component("ID"),
      tipo: ITipo_Campo.key,
      title: "ID",
      sorteditmode: 0,
      hideColOnEdit: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.ID_EMPRESA_INSPECTORA, {
      id: "ID_EMPRESA_INSPECTORA",
      cell: (info: CellContext<ILIOPrevencionista, number>) => componentValue(info.getValue()),
      header: () => component("Empresa inspectora"),
      tipo: ITipo_Campo.combo,
      title: "Empresa inspectora",
      sorteditmode: 1,
      required: true,
      hide: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_EMPRESA_INSPECTORA, {
      id: "NOMBRE_EMPRESA_INSPECTORA",
      cell: (info: CellContext<ILIOPrevencionista, string>) => componentValue(info.getValue()),
      header: () => component("Empresa Inspectora"),
      tipo: ITipo_Campo.text,
      title: "Empresa Inspectora",
      sorteditmode: 1,
      hideColOnEdit: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.ID_GERENCIA, {
      id: "ID_GERENCIA",
      cell: (info: CellContext<ILIOPrevencionista, number>) => componentValue(info.getValue()),
      header: () => component("Zona (Gerencia)"),
      tipo: ITipo_Campo.combo,
      title: "Zona (Gerencia)",
      sorteditmode: 2,
      required: true,
      hide: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_GERENCIA, {
      id: "NOMBRE_GERENCIA",
      cell: (info: CellContext<ILIOPrevencionista, string>) => componentValue(info.getValue()),
      header: () => component("Zona (Gerencia)"),
      tipo: ITipo_Campo.text,
      title: "Zona (Gerencia)",
      sorteditmode: 2,
      hideColOnEdit: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_INSPECTOR_CONTRATISTA, {
      id: "NOMBRE_INSPECTOR_CONTRATISTA",
      cell: (info: CellContext<ILIOPrevencionista, number>) => componentValue(info.getValue()),
      header: () => component("Inspector Contratista"),
      tipo: ITipo_Campo.combo,
      title: "Inspector Contratista",
      sorteditmode: 3,
      required: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_PREVENCIONISTA_EMPRESA_INSPECTORA, {
      id: "NOMBRE_PREVENCIONISTA_EMPRESA_INSPECTORA",
      cell: (info: CellContext<ILIOPrevencionista, string>) => componentValue(info.getValue()),
      readonly: true,
      header: () => component("Prevencionista Empresa Inspectora"),
      tipo: ITipo_Campo.text,
      title: "Prevencionista Empresa Inspectora",
      sorteditmode: 4,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<ILIOPrevencionista, boolean>) => componentValue(info.getValue() === true ? "Sí" : "No"),
      header: () => component("Activo"),
      tipo: ITipo_Campo.check,
      title: "Activo",
      sorteditmode: 5,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.ID_EMPRESA_INSPECCIONADA, {
      id: "ID_EMPRESA_INSPECCIONADA",
      cell: (info: CellContext<ILIOPrevencionista, number>) => componentValue(info.getValue()),
      header: () => component("Empresa Inspeccionada"),
      tipo: ITipo_Campo.combo,
      title: "Empresa Inspeccionada",
      sorteditmode: 6,
      hide: true,
      required: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_EMPRESA_INSPECCIONADA, {
      id: "NOMBRE_EMPRESA_INSPECCIONADA",
      cell: (info: CellContext<ILIOPrevencionista, string>) => componentValue(info.getValue()),
      header: () => component("Empresa Inspeccionada"),
      tipo: ITipo_Campo.combo,
      title: "Empresa Inspeccionada",
      sorteditmode: 6,
      hideColOnEdit: true,
    } as any),
    columnLIOPrevencionista.accessor((row) => row.NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA, {
      id: "NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA",
      cell: (info: CellContext<ILIOPrevencionista, string>) => componentValue(info.getValue()),
      header: () => component("Prevencionista Empresa Inspeccionada"),
      tipo: ITipo_Campo.combo,
      title: "Prevencionista Empresa Inspeccionada",
      required: true,
      sorteditmode: 7,
    } as any),
    columnLIOPrevencionista.display({
      id: "editar",
      header: () => component("Editar"),
      tipo: ITipo_Campo.button,
      texto: "Editar",
      cell: (props: CellContext<ILIOPrevencionista, number>) => linkRender(),
    } as any),
  ] as any;
  usePromiseEffect(async () => {
    if (!loaded) {
      setIsLoading(true);
      let token = await userInfo;
      setToken(token);
      let params = {
        PAGINA: 1,
        PAGINADO: pageSize,
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        TITULO: null,
        USUARIO: null,
        ID_GERENCIA_SUBGERENCIA: null,
        ACTIVO: null,
      };
      let result = is_test
        ? { data: [{}], pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, params))
            .result;

      setIsLoading(false);
      let pages = result.pages;
      setPages(pages);

      params.PAGINADO = ROW_COUNT_MAX;
      let list = is_test
        ? []
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/GetAll`, { Authorization: `Bearer ${token}` }, params)).result.data;
      setComboEI(list);

      filter(params, true);
      setIsLoading(false);
      setLoaded(true);
    } else {
      setListItems([...listItems]);
    }
  }, [token, txtPrevencionista]);

  const fromSelected = async (params: any) => {
    await parentchild("ID_EMPRESA_INSPECTORA", params.ID_EMPRESA_INSPECTORA);
    await parentchild("ID_GERENCIA", params.ID_GERENCIA);
    await parentchild("NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA", params.ID_EMPRESA_INSPECCIONADA);
    setPrevencionista(params.NOMBRE_PREVENCIONISTA_EMPRESA_INSPECTORA);
    let prevencionista = comboEID2.filter((c) => c.ID === parseInt(params.ID_EMPRESA_INSPECCIONADA));
    setComboPEI(prevencionista);
    setPrevencionistaInspeccionada(params.NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA);
    setSelectedItem(params);
    setSelected(params.ID);
  };
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);
        setListItems(result.result.data);
      })
      .catch((error) => {});
  };

  const edit = (value: any, filters: any) => {
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    let obj = {};
    let inspector_contratista = comboIC
      .filter((d) => {
        return d.TITULO === value.NOMBRE_INSPECTOR_CONTRATISTA || d.ID.toString() === value.NOMBRE_INSPECTOR_CONTRATISTA;
      })
      .pop();
    if (selected > 0) {
      value.ID = selected;

      obj = {
        ID: value.ID,
        ID_EMPRESA_INSPECCIONADA: isNaN(value.NOMBRE_EMPRESA_INSPECCIONADA) ? value.ID_EMPRESA_INSPECCIONADA : value.NOMBRE_EMPRESA_INSPECCIONADA,
        ID_EMPRESA_INSPECTORA: isNaN(value.NOMBRE_EMPRESA_INSPECTORA) ? value.ID_EMPRESA_INSPECTORA : value.NOMBRE_EMPRESA_INSPECTORA,
        ID_INSPECTOR_CONTRATISTA: comboIC
          .filter((c) => c.TITULO === value.NOMBRE_INSPECTOR_CONTRATISTA || c.ID === parseInt(value.NOMBRE_INSPECTOR_CONTRATISTA))
          .pop()?.ID,
        ID_GERENCIA: isNaN(value.NOMBRE_GERENCIA) ? value.ID_GERENCIA : value.NOMBRE_GERENCIA,
        ID_REL: value.ID_REL,
        ID_PREVENCIONISTA_EMPRESA_INSPECCIONADA: comboPEI.pop()?.ID,
        PREVENCIONISTA_EMPRESA_INSPECTORA: txtPrevencionista,
        PREVENCIONISTA_EMPRESA_INSPECCIONADA: txtPrevencionistaInspeccionada,
        INSPECTOR_CONTRATISTA: inspector_contratista?.TITULO,
        ACTIVO: value.ACTIVO,
      };
    } else {
      obj = {
        ID: value.ID,
        ID_EMPRESA_INSPECCIONADA: value.ID_EMPRESA_INSPECCIONADA,
        ID_EMPRESA_INSPECTORA: value.ID_EMPRESA_INSPECTORA,
        ID_INSPECTOR_CONTRATISTA: value.NOMBRE_INSPECTOR_CONTRATISTA,
        ID_GERENCIA: value.ID_GERENCIA,
        ID_REL: value.ID_REL,
        ID_PREVENCIONISTA_EMPRESA_INSPECCIONADA: value.NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA,
        PREVENCIONISTA_EMPRESA_INSPECTORA: txtPrevencionista,
        PREVENCIONISTA_EMPRESA_INSPECCIONADA: txtPrevencionistaInspeccionada,
        INSPECTOR_CONTRATISTA: inspector_contratista?.TITULO,
        ACTIVO: value.ACTIVO,
      };
    }

    postAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/PostEmpresaInspectora`, obj, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        setSelected(data.data);
        filter(filters, value?.ID > 0);
        obj = {
          ACTIVO: true,
          ID: 0,
          ID_EMPRESA_INSPECCIONADA: 0,
          ID_EMPRESA_INSPECTORA: 0,
          ID_GERENCIA: 0,
          ID_REL: 0,
          NOMBRE_EMPRESA_INSPECCIONADA: "",
          NOMBRE_EMPRESA_INSPECTORA: "",
          NOMBRE_GERENCIA: "",
          NOMBRE_INSPECTOR_CONTRATISTA: "",
          NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONAD: "",
          NOMBRE_PREVENCIONISTA_EMPRESA_INSPECTORA: "",
        };
        setSelectedItem(obj);
        setPrevencionista("");
        setPrevencionistaInspeccionada("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const parentchild = async (id: string, valor: any) => {
    if (id === "ID_EMPRESA_INSPECTORA") {
      let paramsE = { ID: valor };
      const combo = is_test
        ? []
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/GetByContratistaResponsable`, { Authorization: `Bearer ${token}` }, paramsE)).result
            .data;
      setComboGrc([...combo]);
    }

    if (id === "ID_GERENCIA") {
      let paramsG = { ID: valor };
      const combo1 = is_test
        ? []
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_RESPONSABLE}/GetByIdGerencia`, { Authorization: `Bearer ${token}` }, paramsG)).result
            .data;
      setComboIC([...combo1]);

      const comboCB = is_test
        ? []
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/GetByIdGerencia`, { Authorization: `Bearer ${token}` }, paramsG))
            .result.data;
      setComboEID([...comboCB]);
      comboEID2 = comboCB as IEmpresaInspeccionada[];
    }

    if (id === "NOMBRE_INSPECTOR_CONTRATISTA") {
      let prevencionista = comboIC.filter((c) => c.ID === parseInt(valor)).pop();
      setPrevencionista(prevencionista !== undefined ? prevencionista.PREVENCIONISTA_INSPECTOR : "");
    }

    if (id === "ID_EMPRESA_INSPECCIONADA") {
      let prevencionista = comboEID.filter((c) => c.ID === parseInt(valor));
      setComboPEI(prevencionista);
    }

    if (id === "NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA") {
      let prevencionista = comboPEI.filter((c) => c.ID === parseInt(valor)).pop();
      setPrevencionistaInspeccionada(prevencionista !== undefined ? prevencionista.PREVENCIONISTA : "");
    }
  };

  return (
    <>
      {" "}
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
          filter({});
          filter({ PAGINA: 1 });
          filter({ PAGINA: 1 }, true, 1);
          filter({ PAGINA: undefined }, false);
          paging(1);
          parentchild("ID_EMPRESA_INSPECTORA", "");
          parentchild("NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA", "");
          parentchild("ID_EMPRESA_INSPECCIONADA", "");
          parentchild("NOMBRE_INSPECTOR_CONTRATISTA", "");
          parentchild("ID_GERENCIA", "");
          fromSelected({
            ID_EMPRESA_INSPECTORA: 1,
            NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA: "",
            ID_EMPRESA_INSPECCIONADA: 1,
            NOMBRE_INSPECTOR_CONTRATISTA: "",
            ID_GERENCIA: 1,
          });
        }}></button>
      <AdminLista
        selectedItem={selectedItem}
        loadFromSelected={fromSelected}
        reload={filter}
        items={[
          {
            type: "ID_GERENCIA",
            value: comboGrc.map((grc) => {
              return { text: grc.TITULO, value: grc.ID };
            }),
          },
          {
            type: "ID_EMPRESA_INSPECTORA",
            value: comboEI.map((Cs) => {
              return { text: Cs.TITULO, value: Cs.ID };
            }),
          },
          {
            type: "NOMBRE_INSPECTOR_CONTRATISTA",
            value: comboIC.map((Cs) => {
              return { text: Cs.TITULO, value: Cs.ID };
            }),
          },
          {
            type: "NOMBRE_PREVENCIONISTA_EMPRESA_INSPECTORA",
            value: txtPrevencionista,
          },
          {
            type: "ID_EMPRESA_INSPECCIONADA",
            value: comboEID.map((Cs) => {
              return { text: Cs.TITULO, value: Cs.ID };
            }),
          },
          {
            type: "NOMBRE_PREVENCIONISTA_EMPRESA_INSPECCIONADA",
            value: comboPEI.map((Cs) => {
              return { text: Cs.PREVENCIONISTA, value: Cs.ID };
            }),
          },
        ]}
        callback={edit}
        parentchild={parentchild}
        hideAddForm={false}
        data={listItems}
        tipo={"LIOPrevencionista"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Empresa Inspectora"
        columnsDef={columnsDef}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default LIOPrevencionista;
